import React from "react";
import DescriptionIcon from '@mui/icons-material/Description';
import { Grid, Typography, Alert, ListItemText, List, ListItem, ListItemIcon } from "@mui/material";
import { useTranslation } from "react-i18next";

function Block1() {
    const { t } = useTranslation();
    return (
        <>
            <style>
                {`
                    .MuiAlert-icon {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                    }
                `}
            </style>
            <Grid item sm={8} sx={{ textAlign: "center", backgroundColor: "#004EAA", py: 1, color: "#fff" }}>
                <Typography variant="h1">
                  {t("HOME.FIRST_TIME")}
                </Typography><br></br>
                <Typography sx={{ mb: 1 }} variant="h3" style={{ fontWeight: 400, color: "#fff" }}>
                    {t("HOME.FIRST_TIME_DESCRIPTION")}
                </Typography>
            </Grid>

            <Grid item sm={12} sx={{ mb: 0 }}>
                <Typography variant="h3" style={{ color: "#9568C6", fontWeight: 500 }}> <br />
                    {t("BLOCK_1.REQUIREMENTS_DESCRIPTION")}
                </Typography>

                <List sx={{ width: '100%' }}>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        {t("BLOCK_1.BIRTH_CERTIFICATE")}
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>
                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        {t("BLOCK_1.PAYMENT_RECEPT")}
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        CURP
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        {t("BLOCK_1.ID")}
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>
                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        {t("BLOCK_6.ADDRESS_PROOF")}
                                    </Typography>
                                </React.Fragment>
                            }
                            secondary={
                                <React.Fragment>
                                    {<Typography>
                                        {t("BLOCK_6.ADDRESS_PROOF_DESCRIPTION")}
                                    </Typography>}
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        {t("BLOCK_1.MOTORCYCLE_REQUIREMENTS")} 
                                    </Typography>
                                </React.Fragment>}
                        />
                    </ListItem>     
                    <ListItem alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 40, marginTop: 0 }}>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="h4"
                                        color="text.primary"
                                    >
                                        {t("BLOCK_1.TUTOR")}
                                    </Typography>
                                </React.Fragment>}
                            secondary={
                                <React.Fragment>
                                    {<Typography>
                                        
                                    </Typography>}
                                </React.Fragment>
                            }
                        />
                    </ListItem>                    
                </List>
                <Typography sx={{ fontSize: "15px" }}>
                    <span style={{ color: "#9568C6", fontWeight: "bold" }}> {t("BLOCK_6.MOTORCYCLE")}: </span>
                    {t("BLOCK_6.MOTORCYCLE_DESCRIPTION")}
                </Typography>
            </Grid>
            <Grid container rowSpacing={2}>
                <Grid item sm={12}>
                    <Typography sx={{ fontSize: "15px", textAlign: 'center' }}>
                        {t("BLOCK_6.ARTICLE_LAW")}           
                    </Typography>
                </Grid>
            </Grid>
            <Grid container sx={{ paddingLeft: '27px', paddingRight: '27px' }}>
                <Grid item xs={12} md={12} lg={12} sx={{ mb: 2, mt: 2 }}>
                <Alert severity="info" variant="outlined">
                    <Typography variant="h4" style={{ color: "#9568C6", fontWeight: 500 }}>
                    {t("BLOCK_1.IMPORTANT_MESSAGES")}
                    </Typography>
                    <Typography variant="h4" style={{ fontWeight: 500 }}>
                        · {t("BLOCK_1.ON_TIME")}
                    </Typography>
                    <Typography variant="h4" style={{ fontWeight: 500 }}>
                        ·   {t("BLOCK_1.PRINT_APPOINTMENT")}
                    </Typography>
                    <Typography variant="h4" style={{ fontWeight: 500 }}>
                        ·  {t("BLOCK_1.REQUIREMENTS_CHECK")}
                    </Typography>
                    <Typography variant="h4" style={{ fontWeight: 500 }}>
                        ·  {t("BLOCK_1.PAYMENT_INFO")}
                    </Typography>
                    <Typography variant="h4" style={{ fontWeight: 500 }}>
                        ·  {t("BLOCK_1.WHERE_PAY")}                  
                    </Typography>
                </Alert>
                </Grid>
            </Grid>
        </>
    );
}
export default Block1;